import React, { useEffect, useState } from 'react'
import {
  Modal,
  message,
  Form,
} from "antd";
import Select from "react-select";
import axiosInstance from '../../../utils/axiosInstance';
import { useSelector } from 'react-redux';
import { useTheme } from '../../../utils/themeToggle/theme';


const AssignOtherUser = ({ isAssignModal, handleCancel, assingSenderId, onSuccessAssign, role }) => {
  const [form] = Form.useForm();
  const [assignee, setAssignee] = useState([]);
  const comp_id = useSelector((state) => state.auth.userInfo.company_id);
  const conpanyId = localStorage.getItem("companyId") || comp_id;
  const { reactSelectTheme } = useTheme();

  useEffect(() => {
    fetchAssignee(role);
    form.resetFields();
  }, [role]);

  const handleOk = () => {
    form.submit();
  };

  const fetchAssignee = async (role) => {
    try {
      const response = await axiosInstance.post(`/get-users-by-admin/`, { role, company_id: conpanyId })
      setAssignee(response.data); // Update the state with the fetched user data
    } catch (error) {
      console.error(error);
    }
  };

  const onFinishAssignee = () => {
    form.validateFields();
    const values = form.getFieldsValue();
    const payload = {
      sender_id: assingSenderId,
      assign_id: values.user_id.value
    }
    axiosInstance.put(`/assign-agreements/`, payload)
      .then((response) => {
        message.success("Agreements assigned successfully.");
        form.resetFields();
        onSuccessAssign()
      })
      .catch((error) => {
        console.error("API Error:", error); // Error ko log karo
        console.error("Error Message:", error?.message); // Detailed error message
      });
  };

  return (
    <Modal
      title="Add New Assignee"
      open={isAssignModal}
      onOk={() => handleOk()}
      onCancel={handleCancel}
      style={{ fontSize: "24px", padding: "40px" }}
      okText="Save"
      okButtonProps={{
        style: {
          backgroundColor: "#4E36A3",
          color: "white",
          height: "40px",
          width: "100px",
        },
      }} // Set background color for the Ok button
      cancelButtonProps={{
        style: {
          backgroundColor: "",
          color: "#4E36A3",
          height: "40px",
          width: "100px",
        },
      }} // Set background color for the Cancel button
    >
      <Form form={form} onFinish={onFinishAssignee}>
        <Form.Item
          name="user_id"
          label=""
          style={{ marginBottom: 20 }}
          rules={[
            {
              required: true,
              message: "Please select a assignee",
            },
          ]}
        >
          <Select
            options={
              assignee
                ? Object.values(assignee).filter((item => item.id != assingSenderId)).map((user) => ({
                  value: user.id,
                  label: user.first_name,
                }))
                : []
            }
            // onChange={(selectedOption) =>
            //     setDepartment(selectedOption.value)
            // }
            styles={reactSelectTheme}
            required
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
export default AssignOtherUser